// extracted by mini-css-extract-plugin
export default {"buildButton":"BuildButton_buildButton__HpBcG","spinner":"BuildButton_spinner__9G6Bs"};